import { useEffect, useRef, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import First from 'components/news/list/First';
import { INews, ISearchInfo } from 'types/news';
import Loading from 'components/common/Loading';
import Card from 'components/news/list/Card';

const NewsList = () => {
    const [list, setList] = useState<INews[]>([]);
    const [searchInfo, setSearchInfo] = useState<ISearchInfo>({
        fromDate: '',
        toDate: '',
        region: '',
        search: '',
        page: 1,
    });
    const [hasMore, setHasMore] = useState<boolean>(true);
    const observerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        loadData();
    }, [searchInfo]);

    useEffect(() => {
        if (!hasMore) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setSearchInfo((p) => ({
                        ...p,
                        page: p.page + 1,
                    }));
                }
            },
            { threshold: 1 }
        );

        const target = observerRef.current;
        if (target) observer.observe(target);

        return () => {
            if (target) observer.unobserve(target);
        };
    }, [hasMore, list]);

    const loadData = async () => {
        try {
            const params = new URLSearchParams(Object.entries(searchInfo)).toString();
            const res = await jsonAxios.get(`articles?${params}`);
            if (res.data.code === 200) {
                setHasMore(true);
                const newData = res.data.data;
                if (searchInfo.page === 1) {
                    setList(newData);
                }
                else {
                    setList(p => [...p, ...newData]);
                }
            }
            else if (res.data.code === 400) {
                setHasMore(false);
            }
        }
        catch (err) {
            console.error(err);
        }
    };

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <Container className="flex flex-col gap-10 tablet:gap-4 mb-6 pt-21 tablet:pt-6 h-full min-h-dvh">
                <First
                    searchInfo={searchInfo}
                    setSearchInfo={setSearchInfo}
                />

                {
                    list.length > 0 ?
                        <div className='tablet:flex flex-col gap-x-6 gap-y-10 grid grid-cols-3'>
                            {
                                list.map((item, idx) => (
                                    <Card item={item} idx={idx} key={idx} />
                                ))
                            }
                            {/* 관찰 대상 */}
                            {hasMore && (
                                <div
                                    ref={observerRef}
                                    className="flex justify-center items-center col-span-3 h-10"
                                >
                                    <Loading />
                                </div>
                            )}
                        </div>
                        :
                        <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                            데이터가 없습니다.
                        </div>
                }
            </Container>
        </PageTemplate>
    )
}

export default NewsList